import React from "react";
import EntityList from "../../EntityList/EntityList";
import moment from "moment";
import { defineMessages, injectIntl } from "react-intl";
import swal from "sweetalert";
import { RESTRICTION_TYPE } from "../../../Common/constants";

const messages = defineMessages({
  monday: {
    id: "app.periodConditions.monday",
    description: "Monday",
    defaultMessage: "Monday",
  },
  tuesday: {
    id: "app.periodConditions.tuesday",
    description: "Tuesday",
    defaultMessage: "Tuesday",
  },
  wednesday: {
    id: "app.periodConditions.wednesday",
    description: "Wednesday",
    defaultMessage: "Wednesday",
  },
  thursday: {
    id: "app.periodConditions.thursday",
    description: "Thursday",
    defaultMessage: "Thursday",
  },
  friday: {
    id: "app.periodConditions.friday",
    description: "Friday",
    defaultMessage: "Friday",
  },
  saturday: {
    id: "app.periodConditions.saturday",
    description: "Saturday",
    defaultMessage: "Saturday",
  },
  sunday: {
    id: "app.periodConditions.sunday",
    description: "Sunday",
    defaultMessage: "Sunday",
  },
  create: {
    id: "app.periodConditions.addCloseBookingDates",
    description: "Add close booking dates",
    defaultMessage: "Add close booking dates",
  },
  deleteConfirmation: {
    id: "app.entityList.confirmation",
    description: "Confirmation Question",
    defaultMessage: "Are you sure?",
  },
  deleteConfirmationWarning: {
    id: "app.entityList.deleteConfirmationWarning",
    description: "Confirmation Warning",
    defaultMessage: "Once deleted, you will not be able to recover this entity!",
  },
  ok: {
    id: "default.ok",
    description: "Ok",
    defaultMessage: "Ok",
  },
  cancel: {
    id: "default.cancel",
    description: "Cancel",
    defaultMessage: "Cancel",
  },
  allDays: {
    id: "app.periodConditions.allDays",
    description: "All days of the week",
    defaultMessage: "All",
  },
});

function customEntityToListValuesMapper({ entities, intl }) {
  return entities.map(entity => {
    const restriction =
      entity.restrictions &&
      entity.restrictions[RESTRICTION_TYPE.CLOSE_BOOKING] &&
      entity.restrictions[RESTRICTION_TYPE.CLOSE_BOOKING][0];

    entity.startDate = restriction ? restriction.startDate : null;
    entity.endDate = restriction ? restriction.endDate : null;

    if (restriction && Array.isArray(restriction.weekDays)) {
      const weekDays = restriction.weekDays;
      entity.weekDays =
        weekDays.length === 0
          ? intl.formatMessage(messages.allDays)
          : weekDays.map(weekday => intl.formatMessage(messages[weekday.toLowerCase()])).join();
    }

    entity.timeZone = restriction ? restriction.timeZone : undefined;
    entity.hourRange =
      restriction && restriction.startHour
        ? `${moment(restriction.startHour).format("HH:mm")} - ${moment(
            restriction.endHour
          ).format("HH:mm")}`
        : undefined;

    return entity;
  });
}

class PromotionsCloseBookingWindowList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  handleToggle({ event, field, entity, idx }) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onToggleListItem({ id: entity.id, entity, idx, field });
  }

  handleDelete({ event, entity, idx }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onDeleteListItem({ id: entity.id, entity, idx });
  }

  handleSort({ event, field, entity, newIndex, oldIndex, swappedEntity }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onSortListItem({ id: entity.id, entity, field, newIndex, swappedEntity, oldIndex });
  }

  render() {
    const { config, intl } = this.props;
    const { name, validation, fields, renderers, sorting, locale } = config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      nested,
      entityName,
      disabled,
    } = this.props;
    const { handleToggle, handleDelete, handleSort } = this;

    const deleteCustomAction = [
      {
        icon: "fa fa-trash-o",
        classNames: "btn-danger",
        tooltipId: "closeBookingWindowDelete",
        tooltipText: intl.formatMessage(messages.deleteConfirmation),
        onExecute: ({ event, entity }) => {
          const idx = entities.findIndex(
            e => e === entity || (e._tempId !== undefined && e._tempId === entity._tempId)
          );
          swal({
            title: intl.formatMessage(messages.deleteConfirmation),
            text: intl.formatMessage(messages.deleteConfirmationWarning),
            icon: "warning",
            buttons: {
              cancel: intl.formatMessage(messages.cancel),
              confirm: {
                text: intl.formatMessage(messages.ok),
                closeModal: false,
                value: true,
              },
            },
            dangerMode: true,
          }).then(willDelete => {
            if (willDelete) {
              handleDelete({ event, entity, idx });
              swal.close();
            }
          });
        },
      },
    ];

    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onSort={handleSort}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        nested={nested}
        sorting={sorting}
        customEntityToListValuesMapper={customEntityToListValuesMapper}
        currentLocale={locale}
        customCreateButtonMessage={messages}
        showEmptyListColumnNames={false}
        customActions={deleteCustomAction}
        disabled={disabled}
      />
    );
  }
}

PromotionsCloseBookingWindowList.propTypes = {};
PromotionsCloseBookingWindowList.defaultProps = {};

export default injectIntl(PromotionsCloseBookingWindowList);

